namespace RioERP.Masters {
    export interface CoursesForm {
        Name: Serenity.StringEditor;
    }

    export class CoursesForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.Courses';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CoursesForm.init)  {
                CoursesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(CoursesForm, [
                    'Name', w0
                ]);
            }
        }
    }
}
